import {Component, OnInit, Output, EventEmitter, Input, ChangeDetectorRef, ViewChild, ElementRef} from '@angular/core';

@Component({
  selector: 'app-counter',
  templateUrl: './counter.component.html',
  styleUrls: ['./counter.component.scss']
})
export class CounterComponent implements OnInit {
  @Output() onChange = new EventEmitter<number>();
  @Input() max: number;
  @Input() min: number = 0;
  @Input() reachedMaximumPaxAndIsBlocking: boolean;
  @ViewChild('input') input: ElementRef;
  private _count;

  constructor(private _cdRef: ChangeDetectorRef) { }

  ngOnInit() {
  }

  increment() {
    if (this.max === undefined || this.count < this.max) {
      this.count += 1;
    }
  }

  decrement() {
    if (this.count > 0) {
      this.count -= 1;
    }
  }

  parseInt(value: string): number {
    return parseInt(value, 0);
  }

  updateValue(value: any) {
    if (value !== null) {
      const previousAccountValue = this.count.toFixed(0);
      if (this.max !== undefined && value > this.max) {
        this.count = this.max;
      } else if (value < this.min) {
        this.count = this.min;
      } else {
        this.count = value;
      }

      this.input.nativeElement.value = this.count;
      this._cdRef.detectChanges();

      if (this.count.toFixed(0) !== previousAccountValue) {
        this.onChange.emit(this.count);
      }
    }
  }

  @Input('count') set count(value: number) {
    if (this._count === undefined) {
      this._count = value;
    } else if (this._count !== value) {
      this._count = value;
      this.onChange.emit(this.count);
    }
  }

  get count(): number {
    return this._count || 0;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/atoms/counter/counter.component.ts